import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ConstructionWorkerRegistrationProjects from '@/components/dashboard/ConstructionWorkerRegistrationProjects.vue'
import TimeRegistrationProjects from '@/components/dashboard/TimeRegistrationProjects.vue'
import { authStore } from '@/stores/auth'
import PageTitleBar from '@/components/PageTitleBar.vue'
import IssueWidget from '@/components/dashboard/IssueWidget.vue'
import { can, canAny } from '@/globalFunctions'

export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Dashboard")
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode("Welkom terug, " + _toDisplayString(_unref(authStore)().user.firstname) + "!", 1)
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, { gutter: [16,16] }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            (_unref(canAny)(['construction_site_portal.issues.view', 'construction_site_portal.issues.edit']))
              ? (_openBlock(), _createBlock(IssueWidget, { key: 0 }))
              : _createCommentVNode("", true),
            (_unref(authStore)().isInternal && _unref(can)('construction_site_portal.construction_site_registrations.edit'))
              ? (_openBlock(), _createBlock(ConstructionWorkerRegistrationProjects, { key: 1 }))
              : (_unref(can)('construction_site_portal.time_registrations.edit'))
                ? (_openBlock(), _createBlock(TimeRegistrationProjects, { key: 2 }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})